<div class="flex flex-col justify-between overflow-hidden gap-2">
  <div
    class="font-medium text-gray-400 pl-6 text-xs">{{ stateService.selectedProject ? "Organisation & Projekt" : "Organisation & Projekte" }}
  </div>

  <!--  Organisation-->
  <div class="flex flex-row" (mouseenter)="hoveringOrga = true" (mouseleave)="hoveringOrga = false" >
    <div class="flex w-full pl-4 pr-3">
      <div
        class="flex flex-row justify-between items-center py-1 pl-2 w-full hover:bg-[rgba(255,255,255,0.35)] cursor-pointer hover:rounded-lg">

        <!--        [matTooltip]="'Organisation'"-->
        <div (click)="routeToOrganisations()" class="flex flex-row text-base font-medium items-center w-full gap-4 break-all line-clamp-1" [attr.title]="stateService.selectedOrganisation?.name || (stateService.isPersonal ? 'Persönlich' : 'Organisationsübersicht')">
          <!--      Icon-->
          <div class="flex flex-row justify-center items-center flex-shrink-0">
            <div class="flex justify-center items-center text-center h-8 w-8 flex-shrink-0"
              [ngClass]="{'rounded-full bg-[rgba(255,255,255,0.35)]': !hoveringOrga}">
              <fa-icon [fixedWidth]="true" [icon]="faUsers" class="text-base text-white"></fa-icon>
            </div>
          </div>
          <!--      Text-->
          <div class="line-clamp-1">
            {{ stateService.selectedOrganisation ? stateService.selectedOrganisation?.name : (stateService.isPersonal ? "Persönlich" : "Organisationsübersicht") }}
          </div>
        </div>
        @if (hoveringOrga && stateService.selectedOrganisation?.name) {
          <div [routerLink]="['organisations', stateService.selectedOrganisation.id!, 'settings']"
               (click)="$event.stopPropagation()"
               class="flex flex-row px-2 py-1"
               tooltip="Organisationseinstellungen" tooltipDirection="right" tooltipColor="light">
            <fa-icon [icon]="faGear" class=" text-white"></fa-icon>
          </div>
        }
      </div>
    </div>
  </div>


  <!--  Projekt-->
  <div class="flex flex-row" (mouseenter)="hovering = true" (mouseleave)="hovering = false" >
    <div class="flex w-full pl-4 pr-3">
      <!-- Ohne Organisations- bzw. Persoenlich-Kontext ist der Eintrag gesperrt: verbotener
           Mauszeiger + Tooltip statt einer leeren Projektuebersicht. Der Tooltip wird bewusst
           nur hier angehaengt - ein leerer tooltip-Text wuerde eine leere Sprechblase zeigen. -->
      @if (projectOverviewBlocked) {
        <div class="flex flex-row justify-between items-center py-1 pl-2 w-full cursor-not-allowed"
             tooltip="Bitte wählen Sie zuerst eine Organisation aus." tooltipDirection="bottom"
             tooltipColor="light">
          <ng-container [ngTemplateOutlet]="projectEntry"></ng-container>
        </div>
      } @else {
        <div class="flex flex-row justify-between items-center py-1 pl-2 w-full hover:bg-[rgba(255,255,255,0.35)] cursor-pointer hover:rounded-lg">
          <ng-container [ngTemplateOutlet]="projectEntry"></ng-container>
        </div>
      }
    </div>
  </div>
</div>

<ng-template #projectEntry>
  <!--        [matTooltip]="stateService.selectedProject?.name ? 'Projekt' : ''"-->
  <div (click)="openProjectOverview()" class="flex flex-row text-base font-medium items-center w-full gap-4 break-all line-clamp-1" [attr.title]="projectOverviewBlocked ? null : (stateService.selectedProject?.name || 'Projektübersicht')">
    <!--      Icon-->
    <div class="flex flex-row justify-center items-center flex-shrink-0">
      <div class="flex justify-center items-center text-center h-8 w-8 flex-shrink-0"
        [ngClass]="{'rounded-full bg-[rgba(255,255,255,0.35)]': !hovering || projectOverviewBlocked}">
        <fa-icon [fixedWidth]="true" [icon]="faBuilding"
                 class="text-base text-white"></fa-icon>
      </div>
    </div>
    <p class="line-clamp-1">
      {{ stateService.selectedProject?.name ?? "Projektübersicht" }}
    </p>
  </div>
  @if (hovering && stateService.selectedProject?.name) {
    <div [routerLink]="['projects', stateService.selectedProject.id!, 'settings']"
         (click)="$event.stopPropagation()"
         class="flex flex-row px-2 py-1" tooltip="Projekteinstellungen"
         tooltipDirection="right" tooltipColor="light">
      <fa-icon [icon]="faGear" class=" text-white"></fa-icon>
    </div>
  }
</ng-template>
